import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';

import { ImageCropComponent } from './image-crop/image-crop.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { CommentDialogComponent } from './comment-dialog/comment-dialog.component';
import { FieldDialogComponent } from './field-dialog/field-dialog';
import { MonetizationDialogComponent } from './monetization-dialog/monetization-dialog';
import { RewardsDialogComponent } from './rewards-dialog/rewards-dialog';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule.forRoot({
            validationMessages: [
                { name: 'required', message: 'This field is required' },
                { name: 'email', message: 'Email is not in valid format'},
            ],
            validators: [
                { name: 'email', validation: Validators.email },
            ]}),
        FormlyBootstrapModule,
        TranslateModule.forChild(),
    ],
    declarations: [
        ImageCropComponent,
        ConfirmationDialogComponent,
        AlertDialogComponent,
        CommentDialogComponent,
        FieldDialogComponent,
        MonetizationDialogComponent,
        RewardsDialogComponent
    ],
    exports: [
        ImageCropComponent,
        ConfirmationDialogComponent,
        AlertDialogComponent,
        CommentDialogComponent,
        FieldDialogComponent,
        MonetizationDialogComponent,
        RewardsDialogComponent
    ]
})
export class ModalsModule {
}
